export default __webpack_public_path__ + "static/media/about-curve-flip.28a38661.svg";